import { Toolbar } from "@circle-react/components/QuickPostV3/Composer/Toolbar";
import { Topics } from "@circle-react/components/QuickPostV3/Composer/Topics";
import { useComposerSpace } from "@circle-react/components/QuickPostV3/hooks/useComposerSpace";
import { useCoverPicker } from "@circle-react/components/QuickPostV3/hooks/useCoverPicker";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Button } from "@circleco/compass/components/Button";
import { Divider } from "@circleco/compass/components/Divider";

import { t } from "@/i18n-js/instance";

interface FooterToolbarRowProps {
  floating?: boolean;
  inline?: boolean;
}

const FloatingAddCover = () => {
  const { shouldShowAddCover } = useComposerSpace();
  const { openCoverPicker } = useCoverPicker();

  if (!shouldShowAddCover) return null;

  return (
    <div className="absolute bottom-full right-6 z-20 pb-3">
      <Button
        type="button"
        variant="outline"
        size="md"
        startIcon="image"
        onClick={openCoverPicker}
      >
        {t("quick_post_v2.header.add_cover")}
      </Button>
    </div>
  );
};

export const FooterToolbarRow = ({
  inline,
  floating,
}: FooterToolbarRowProps = {}) => {
  if (floating) {
    return (
      <div className="relative shrink-0 lg:px-6">
        <Toolbar floating />
        <FloatingAddCover />
      </div>
    );
  }

  return (
    <div className="shrink-0 px-6">
      <div
        className={classNames(
          "border-primary min-w-0 border-t",
          inline
            ? "flex min-h-16 items-center gap-4 py-1.5"
            : "flex h-16 items-center",
        )}
      >
        <Toolbar shrink={inline} />
        {inline ? (
          <>
            <Divider
              orientation="vertical"
              className="border-primary h-6 shrink-0"
            />
            <div className="min-w-0 flex-1">
              <Topics inline />
            </div>
          </>
        ) : null}
      </div>
      {!inline ? <Topics className="border-primary border-t" /> : null}
    </div>
  );
};
